import { render, staticRenderFns } from "./PreloaderOnCreation.vue?vue&type=template&id=ad4eaf9a&scoped=true&"
var script = {}
import style0 from "./PreloaderOnCreation.vue?vue&type=style&index=0&id=ad4eaf9a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4eaf9a",
  null
  
)

export default component.exports